import { TextButtonLink } from '@creditornot/cb-button';
import { cbSemanticCssVars, colors } from '@creditornot/cb-ingredients';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import { pxToRem } from '@creditornot/cb-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { typographyCss } from 'common/typography';
import { Typography as T } from 'common/typography';

type FreeTrialFormContentDisabledProps = {
  freeTrialToggleChangeHandler: (enabled: boolean) => void;
};

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(16)};
`;

const Title = styled.div`
  ${typographyCss.Title1};
  font-weight: 700;
`;

const Header = styled.div<{ enabled: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${({ enabled }) => (enabled ? colors.wolt8 : 'transparent')};
  padding: ${pxToRem(8)} ${pxToRem(16)};
`;

const DisabledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid;
  border-color: ${cbSemanticCssVars.borderPrimary};
  border-radius: 8px;
  background-color: ${cssThemedValue({ dark: colors.pepper88, light: colors.pepper2 })};
`;

const DisabledBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(0)} ${pxToRem(64)} ${pxToRem(16)};
  gap: ${pxToRem(4)};
`;

export const FreeTrialFormContentDisabled = ({ freeTrialToggleChangeHandler }: FreeTrialFormContentDisabledProps) => {
  return (
    <DisabledContainer data-test-id="free-trial-form-content-disabled">
      <Header enabled={false}>
        <TitleContainer>
          <img src={`${process.env.CDN_URL}/ads/free-trial-coin-disabled.png`} alt="" />
          <Title>
            <FormattedMessage id="campaigns.ads.free-trials.disabled-header" />
          </Title>
        </TitleContainer>
        <TextButtonLink
          data-test-id="free-trial-enable-cta"
          onClick={() => {
            freeTrialToggleChangeHandler(true);
          }}
        >
          <FormattedMessage id="campaigns.ads.free-trials.enable-cta" />
        </TextButtonLink>
      </Header>
      <DisabledBodyContainer>
        <T.Body3>
          <FormattedMessage id="campaigns.ads.free-trials.disable-body-description" />
        </T.Body3>
      </DisabledBodyContainer>
    </DisabledContainer>
  );
};
